import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "p-d-flex" }
const _hoisted_2 = { class: "p-float-label" }
const _hoisted_3 = {
  for: "fileName",
  class: "kn-material-input-label"
}
const _hoisted_4 = {
  key: 0,
  class: "p-fluid p-formgrid p-grid p-mt-3"
}
const _hoisted_5 = { class: "p-field p-float-label p-col" }
const _hoisted_6 = {
  for: "scope",
  class: "kn-material-input-label"
}
const _hoisted_7 = { class: "p-field p-float-label p-col" }
const _hoisted_8 = {
  for: "scope",
  class: "kn-material-input-label"
}
const _hoisted_9 = { class: "p-field p-float-label p-col" }
const _hoisted_10 = {
  for: "scope",
  class: "kn-material-input-label"
}
const _hoisted_11 = { class: "p-field p-float-label p-col" }
const _hoisted_12 = {
  for: "scope",
  class: "kn-material-input-label"
}
const _hoisted_13 = { class: "p-field p-float-label p-col" }
const _hoisted_14 = {
  for: "scope",
  class: "kn-material-input-label"
}
const _hoisted_15 = {
  key: 1,
  class: "p-fluid p-formgrid p-grid p-mt-3"
}
const _hoisted_16 = { class: "p-field p-col" }
const _hoisted_17 = { class: "p-float-label" }
const _hoisted_18 = {
  for: "skipRows",
  class: "kn-material-input-label"
}
const _hoisted_19 = { class: "p-field p-col" }
const _hoisted_20 = { class: "p-float-label" }
const _hoisted_21 = {
  for: "limitRows",
  class: "kn-material-input-label"
}
const _hoisted_22 = { class: "p-field p-col" }
const _hoisted_23 = { class: "p-float-label" }
const _hoisted_24 = {
  for: "sheetnumber",
  class: "kn-material-input-label"
}
const _hoisted_25 = {
  key: 0,
  id: "preview-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Button = _resolveComponent("Button")
  const _component_KnInputFile = _resolveComponent("KnInputFile")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Card = _resolveComponent("Card")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "p-m-2" }, {
      content: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", {
            class: "p-field",
            style: _ctx.fileDescriptor.style.maxwidth
          }, [
            _createVNode("span", _hoisted_2, [
              _createVNode(_component_InputText, {
                id: "fileName",
                class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.dataset.fileName.$invalid && _ctx.v$.dataset.fileName.$dirty
                            }],
                style: _ctx.fileDescriptor.style.maxwidth,
                modelValue: _ctx.v$.dataset.fileName.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.dataset.fileName.$model = $event)),
                modelModifiers: { trim: true },
                disabled: true,
                onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.dataset.fileName.$touch())),
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["style", "modelValue", "class"]),
              _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('downloadsDialog.columns.fileName')) + " * ", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              class: "p-mt-1",
              vComp: _ctx.v$.dataset.fileName,
              additionalTranslateParams: { fieldName: _ctx.$t('downloadsDialog.columns.fileName') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ], 4),
          _createVNode(_component_Button, {
            icon: "fas fa-upload",
            class: "p-button-text p-button-plain p-ml-2",
            onClick: _ctx.setUploadType
          }, null, 8, ["onClick"]),
          _createVNode(_component_Button, {
            icon: "fas fa-download",
            class: "p-button-text y p-button-plain p-ml-2",
            onClick: _ctx.downloadDatasetFile
          }, null, 8, ["onClick"]),
          (!_ctx.uploading)
            ? (_openBlock(), _createBlock(_component_KnInputFile, {
                key: 0,
                changeFunction: _ctx.uploadDatasetFile,
                accept: ".csv, .xls, .xlsx",
                triggerInput: _ctx.triggerUpload
              }, null, 8, ["changeFunction", "triggerInput"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.dataset.fileType && _ctx.dataset.fileType == 'CSV')
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("span", _hoisted_5, [
                _createVNode(_component_Dropdown, {
                  id: "csvDelimiter",
                  class: "kn-material-input",
                  options: _ctx.fileDescriptor.csvDelimiterCharacterTypes,
                  optionLabel: "name",
                  optionValue: "value",
                  modelValue: _ctx.dataset.csvDelimiter,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dataset.csvDelimiter = $event)),
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getPreviewData(false)))
                }, null, 8, ["options", "modelValue"]),
                _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('managers.datasetManagement.ckanCsvDelimiter')), 1)
              ]),
              _createVNode("span", _hoisted_7, [
                _createVNode(_component_Dropdown, {
                  id: "csvQuote",
                  class: "kn-material-input",
                  options: _ctx.fileDescriptor.csvQuoteCharacterTypes,
                  optionLabel: "name",
                  optionValue: "value",
                  modelValue: _ctx.dataset.csvQuote,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.dataset.csvQuote = $event)),
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getPreviewData(false)))
                }, null, 8, ["options", "modelValue"]),
                _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('managers.datasetManagement.ckanCsvQuote')), 1)
              ]),
              _createVNode("span", _hoisted_9, [
                _createVNode(_component_Dropdown, {
                  id: "csvEncoding",
                  class: "kn-material-input",
                  options: _ctx.fileDescriptor.csvEncodingTypes,
                  optionLabel: "name",
                  optionValue: "value",
                  modelValue: _ctx.dataset.csvEncoding,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dataset.csvEncoding = $event)),
                  onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getPreviewData(false)))
                }, null, 8, ["options", "modelValue"]),
                _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('managers.datasetManagement.ckanCsvEncoding')), 1)
              ]),
              _createVNode("span", _hoisted_11, [
                _createVNode(_component_Dropdown, {
                  id: "dateFormat",
                  class: "kn-material-input",
                  options: _ctx.fileDescriptor.dateFormatTypes,
                  optionLabel: "name",
                  optionValue: "value",
                  modelValue: _ctx.dataset.dateFormat,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.dataset.dateFormat = $event)),
                  onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.getPreviewData(false)))
                }, null, 8, ["options", "modelValue"]),
                _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('managers.datasetManagement.ckanDateFormat')), 1)
              ]),
              _createVNode("span", _hoisted_13, [
                _createVNode(_component_Dropdown, {
                  id: "timestampFormat",
                  class: "kn-material-input",
                  options: _ctx.fileDescriptor.timestampFormatTypes,
                  optionLabel: "name",
                  optionValue: "value",
                  modelValue: _ctx.dataset.timestampFormat,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.dataset.timestampFormat = $event)),
                  onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.getPreviewData(false)))
                }, null, 8, ["options", "modelValue"]),
                _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('managers.datasetManagement.timestampFormat')), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.dataset.fileType == 'XLS' || _ctx.dataset.fileType == 'XLSX')
          ? (_openBlock(), _createBlock("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, [
                _createVNode("span", _hoisted_17, [
                  _createVNode(_component_InputText, {
                    id: "skipRows",
                    class: "kn-material-input",
                    type: "number",
                    modelValue: _ctx.dataset.skipRows,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.dataset.skipRows = $event)),
                    modelModifiers: { trim: true },
                    onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.getPreviewData(false)))
                  }, null, 8, ["modelValue"]),
                  _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('managers.datasetManagement.ckanSkipRows')), 1)
                ])
              ]),
              _createVNode("div", _hoisted_19, [
                _createVNode("span", _hoisted_20, [
                  _createVNode(_component_InputText, {
                    id: "limitRows",
                    class: "kn-material-input",
                    type: "number",
                    modelValue: _ctx.dataset.limitRows,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.dataset.limitRows = $event)),
                    modelModifiers: { trim: true },
                    onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.getPreviewData(false)))
                  }, null, 8, ["modelValue"]),
                  _createVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('managers.datasetManagement.ckanLimitRows')), 1)
                ])
              ]),
              _createVNode("div", _hoisted_22, [
                _createVNode("span", _hoisted_23, [
                  _createVNode(_component_InputText, {
                    id: "sheetnumber",
                    class: "kn-material-input",
                    type: "number",
                    modelValue: _ctx.dataset.xslSheetNumber,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.dataset.xslSheetNumber = $event)),
                    modelModifiers: { trim: true },
                    onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.getPreviewData(false)))
                  }, null, 8, ["modelValue"]),
                  _createVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('managers.datasetManagement.ckanXslSheetNumber')), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.rows.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_25, [
          _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-mt-3" }, {
            start: _withCtx(() => [
              (!_ctx.expandTableCard)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "fas fa-chevron-right",
                    class: "p-button-text p-button-rounded p-button-plain",
                    style: {"color":"white"},
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.expandTableCard = true))
                  }))
                : (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    icon: "fas fa-chevron-down",
                    class: "p-button-text p-button-rounded p-button-plain",
                    style: {"color":"white"},
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.expandTableCard = false))
                  })),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('managers.lovsManagement.preview')), 1)
            ]),
            end: _withCtx(() => [
              _withDirectives(_createVNode(_component_Button, {
                icon: "pi pi-refresh",
                class: "p-button-text p-button-rounded p-button-plain p-ml-auto",
                onClick: _ctx.getPreviewData
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('common.refresh'),
                  void 0,
                  { left: true }
                ]
              ])
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(_component_Card, { class: "p-m-2" }, {
            content: _withCtx(() => [
              _createVNode(_component_DataTable, {
                value: _ctx.rows,
                class: "p-datatable-sm kn-table",
                loading: _ctx.loading,
                responsiveLayout: "scroll",
                scrollable: true,
                scrollDirection: "both",
                scrollHeight: "800px",
                stripedRows: "",
                rowHover: "",
                style: {"width":"70vw"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                    return (_openBlock(), _createBlock(_component_Column, {
                      field: col.name,
                      header: col.header,
                      key: col.dataIndex,
                      class: "kn-truncated",
                      style: {"width":"250px"}
                    }, null, 8, ["field", "header"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "loading"])
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.expandTableCard]
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}